// Matches the "Welcome, {name}!" heading + flex-wrap of fixed-size cards shared by
// Organisation.js (256x160 cards) and Integration.js (256x200 cards).
export default function CardWrapSkeleton({ cardHeight = 160, cards = 4 }) {
    return (
        <>
            <div className="row my-5">
                <div className="col-12">
                    <h3>Welcome!</h3>
                    <p>&nbsp;</p>
                </div>
            </div>
            <div className="d-flex flex-wrap gap-3">
                {Array.from({ length: cards }).map((_, i) => (
                    <div key={i} className="shine rounded-3" style={{ width: 256, height: cardHeight }} />
                ))}
            </div>
        </>
    );
}
